<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="rolesSelected"
    :clearable="!unclearable"
    :items="rolesItems"
    :loading="rolesLoading"
    :search-input.sync="rolesSearch"
    item-text="role_name"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Roles.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import Roles from "@/api/roles";

export default {
  name: "SearcherRole",

  props: {
    value: Object,
    type: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    rolesItems() {
      return this.roles.map((role) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == role.id
            )
          : false;
        return Object.assign({}, role, { disabled });
      });
    },
  },

  data: () => ({
    roles: [],
    rolesLoading: false,
    rolesSearch: "",
    rolesSelected: null,
  }),

  mounted() {
    this.getRolesFromAPI();
  },

  methods: {
    getRolesFromAPI() {
      this.rolesLoading = true;
      Roles.fetchAllForSelect()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.roles = response.data.roles;
            }
            this.rolesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.rolesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.rolesSelected = this.value;
      },
    },
    rolesSelected: {
      handler() {
        this.$emit("input", this.rolesSelected);
      },
    },
    type: {
      handler() {
        this.getRolesFromAPI();
      },
    },
  },
};
</script>
